import { render, staticRenderFns } from "./InOrders.vue?vue&type=template&id=5b51408b&lang=pug&"
import script from "./InOrders.vue?vue&type=script&lang=js&"
export * from "./InOrders.vue?vue&type=script&lang=js&"
import style0 from "./InOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports